<template>
    <div class="container-main2">
        <TopNavBar />
        <div class="banner-box">
            <div class="fixed-box" :class="{ active: isFixed }">

                <div class="header center2">
                    <div class="logo" @click="logoClicked()">
                        <img :src="isFixed ? darkLogo : lightLogo" alt="">
                    </div>
                    <div id="menuIcon">
                        <svg @click="isMenu = !isMenu" width="30" height="30" viewBox="0 0 30 30"
                            xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_1_383" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="30"
                                height="30">
                                <rect width="30" height="30" :fill="isFixed ? '#2AA1B6' : '#fff'" />
                            </mask>
                            <g mask="url(#mask0_1_383)">
                                <path
                                    d="M3.75 22.5V20H26.25V22.5H3.75ZM3.75 16.25V13.75H26.25V16.25H3.75ZM3.75 10V7.5H26.25V10H3.75Z"
                                    :fill="isFixed ? '#2AA1B6' : '#fff'" />
                            </g>
                        </svg>
                    </div>
                    <div class="menu" :class="isMenu ? 'block' : 'hidden'">
                        <a v-for="(item, index) in menu" :key="index" href="#" class="Regular-Medium"
                            @click="findActiveMenu(index, $event)">
                            <!-- {{ item.title }} -->
                            <span :class="{ linktext: true, active: item.active && index !== menu.length - 1 }">{{
                                item.title
                            }}</span>
                            <!-- <span class="bottom-margin">asa</span> -->
                        </a>
                    </div>
                </div>


            </div>

        </div>
        <router-view />
        <!--  @childScrollEvent="updateIsFixed"  -->

    </div>
</template>

<script>
// import lightLogo from '@/assets/image/livedesk-logo-light.png';
import lightLogo from '@/assets/image/Livedesk-white-new.svg';

// import darkLogo from '@/assets/image/livedesk-logo-dark.png';
import darkLogo from '@/assets/image/Livedesk-color-new.svg';

import TopNavBar from './TopNavBar.vue'

export default {
    name: 'headerNav',
    components: {
        TopNavBar
    },
    props: {
    },
    data() {
        return {
            darkLogo,
            // lightLogo: '/assets/cwLogos/LiveDesk-Rectangle-Color-No-Slogan-1.svg',
            lightLogo,
            menu: [
                { title: 'Home', active: false },
                { title: 'Pricing', active: false },
                { title: 'FAQs', active: false },
                { title: 'Get in touch', active: false },
                { title: 'Schedule a Demo', active: false },
            ],
            tabs: [
                { title: 'People Benefits', svg: '@/assets/svg/logo.svg' },
                { title: 'OPS Benefits', svg: '@/assets/svg/suggest.svg' },
                { title: 'CX Benefits', svg: '@/assets/svg/satisfied.svg' },
            ],
            isFixed: false,
            isMenu: false
            // activeIndex: 1,
        }
    },
    methods: {
        findActiveMenu(index, e) {
            e.preventDefault()
            this.isMenu = false;
            this.menu.forEach(item => item.active = false)
            this.$nextTick(() => {
                this.menu[index].active = true
                if (index === 0) {
                    if (this.$router.currentRoute.path !== '/') this.$router.push('/')
                    return
                }
                else if (index === 1) {
                    if (this.$router.currentRoute.path !== '/pricing') this.$router.push('/pricing')
                    return
                }
                else if (index === 2) {
                    if (this.$router.currentRoute.path !== '/faqsPage') this.$router.push('/faqsPage')
                    return
                }
                else if (index === 3) {
                    if (this.$router.currentRoute.path !== '/contact') this.$router.push('/contact')
                    return
                }
                else if (index === 4) {
                    if (this.$router.currentRoute.path !== '/bookMeeting') this.$router.push('/bookMeeting')
                    return
                }
            });
        },
        logoClicked() {
            if (this.$router.currentRoute.path !== '/') {
                this.$router.push('/');
                this.menu.forEach(item => item.active = false)
            }
            return;
        },
        updateIsFixed(isFixed) {
            this.isFixed = isFixed;
        },
        scrollEvent() {
            this.isFixed = window.scrollY > 60;
        },
    },
    created() {
        document.addEventListener('scroll', this.scrollEvent)
    }

}
</script>


<style scoped lang="less">
.body {
    overflow-y: auto;
    // height: 100vw;
}

a:hover {
  text-decoration: none;
}

.container-main2 {
    margin: 0 auto;
    background: #F2F3F4;
    overflow: hidden;
}

.center2 {
    margin: 0 auto;
    width: 80%;
}

.banner-box {
    // overflow: hidden;
    // overflow: scroll;
    // overflow-y: scroll;
    width: 100%;
    // background: url('../assets/image/bannerBG.png');

    // background: url("data:image/svg+xml,%3Csvg class='rectangle-685' width='1440' height='768' viewBox='0 0 1440 768' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg filter='url(%23filter0_d_1608_6211)'%3E%3Cpath d='M0 0H1440V636.346C1440 636.346 1003.32 760.2 718.5 760C434.843 759.801 0 636.346 0 636.346V0Z' fill='url(%23paint0_angular_1608_6211)' /%3E%3Cpath d='M0 0H1440V636.346C1440 636.346 1003.32 760.2 718.5 760C434.843 759.801 0 636.346 0 636.346V0Z' fill='url(%23paint1_radial_1608_6211)' /%3E%3Cpath d='M0 0H1440V636.346C1440 636.346 1003.32 760.2 718.5 760C434.843 759.801 0 636.346 0 636.346V0Z' fill='url(%23paint2_angular_1608_6211)' fill-opacity='0.2' /%3E%3Cpath d='M0 0H1440V636.346C1440 636.346 1003.32 760.2 718.5 760C434.843 759.801 0 636.346 0 636.346V0Z' fill='url(%23paint3_linear_1608_6211)' /%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='filter0_d_1608_6211' x='-4' y='0' width='1448' height='768' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix' /%3E%3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' /%3E%3CfeOffset dy='4' /%3E%3CfeGaussianBlur stdDeviation='2' /%3E%3CfeComposite in2='hardAlpha' operator='out' /%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' /%3E%3CfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_1608_6211' /%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_1608_6211' result='shape' /%3E%3C/filter%3E%3CradialGradient id='paint0_angular_1608_6211' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(720 584) rotate(-106.978) scale(1076.61 2896.66)'%3E%3Cstop offset='0.0729167' stop-color='%230C5C6A' /%3E%3Cstop offset='0.161458' stop-color='%232AA1B6' /%3E%3Cstop offset='0.442708' stop-color='%23D5DBE0' /%3E%3Cstop offset='0.621087' stop-color='white' /%3E%3Cstop offset='0.755208' stop-color='white' /%3E%3Cstop offset='0.916667' stop-color='%232AA1B6' /%3E%3Cstop offset='0.958333' stop-color='%230C5C6A' /%3E%3C/radialGradient%3E%3CradialGradient id='paint1_radial_1608_6211' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='rotate(-3.60641) scale(657.415 697.55)'%3E%3Cstop stop-color='%2352CBE0' /%3E%3Cstop offset='1' stop-color='%232AA1B6' stop-opacity='0.2' /%3E%3C/radialGradient%3E%3CradialGradient id='paint2_angular_1608_6211' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(799.5 652.5) rotate(175.106) scale(830.415 2558.69)'%3E%3Cstop stop-color='%230C5C6A' /%3E%3Cstop offset='0.104167' stop-color='%230C5C6A' /%3E%3Cstop offset='0.65625' stop-color='%232698AC' /%3E%3Cstop offset='0.723958' stop-color='%23289CB0' /%3E%3Cstop offset='0.817708' stop-color='%232AA1B6' /%3E%3Cstop offset='0.916667' stop-color='%232AA1B6' /%3E%3C/radialGradient%3E%3ClinearGradient id='paint3_linear_1608_6211' x1='720' y1='0' x2='720' y2='847' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0.0979163' stop-color='%230C5C6A' /%3E%3Cstop offset='1' stop-color='%230C5C6A' stop-opacity='0' /%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E") center/cover;
    background-repeat: no-repeat;
    background-size: 100% 600px;

    .fixed-box {
        width: 100%;
        z-index: 101;
        background: #0C5C6A;
        position: relative;

        .menu {
            display: block;
        }

        &.active {
            position: fixed;
            margin-top: -42px;
            // background-color: rgba(255, 255, 255, 0.8);
            background: rgba(255, 255, 255, 0.80);

            backdrop-filter: blur(25px);
            // height: 89.32038879394531px;
            // z-index: 11000;

            .menu {

                a {
                    .linktext {
                        color: #000000;
                        &.active{
                            color: #2AA1B6;
                            border-bottom: 2px solid #2AA1B6;
                        }
                    }


                    &:last-child {
                        background: linear-gradient(0deg, #2AA1B6, #2AA1B6);
                        border: .5px solid #2AA1B6;
                        .linktext{
                            color: #ffffff;
                        }
                        
                    }
                }
            }

            .header {
                padding-bottom: 16px;
            }
        }
    }

    .header {
        display: flex;
        justify-content: space-between;
        padding-top: 16px;
        padding-bottom: 16px;

        .menu {

            a {
                //styleName: Sec -WEB/Paragraph Regular/Medium;
                // font-family: Roboto;
                // font-size: 16px;
                // font-weight: 500;
                // line-height: 44.5px;
                // letter-spacing: 0em;
                // text-align: center;
                // color: #FFFFFFCC;
                // text-decoration: none;
                padding: 8px 8px 8px 8px;


                .linktext {
                    font-family: Roboto;
                    font-size: 16px;
                    font-weight: 500;
                    line-height: 44.5px;
                    letter-spacing: 0em;
                    text-align: center;
                    color: rgba(255, 255, 255, 0.70);
                    text-decoration: none;
                    padding: 8px 8px 8px 8px;

                    &.active {
                        color: rgba(255, 255, 255, 1);
                        border-bottom: 2px solid #fff;
                        font-weight: 600;
                    }



                }

                &:last-child {
                    margin-left: 16px;
                    border: 1px solid #fff;
                    padding: 8px 16px;
                    border-radius: 4px;
                }

                // &.bottom-margin {
                //     // position: relative;
                //     display: block;
                //     // width: 100%;
                //     border-bottom: 1px solid rgba(255, 255, 255, 1);
                // }


            }
        }

        #menuIcon {
            display: none;
            cursor: pointer;
        }

        @media screen and (max-width:900px) {

            .logo {
                height: 29.5px;

                img {
                    height: 100%;
                }
            }

            .menu {
                position: absolute;
                top: 100%;
                right: 0;
                left: 0;
                padding-bottom: 40px;
                background-color: white;

                a {
                    display: block;
                    border-bottom: 1px solid #D9D9D9;
                    font-size: 36px;

                    .linktext {
                        color: #000000;
                    }

                    .linktext.active {
                        color: #000000;
                    }
                }

                a:nth-last-of-type(2) {
                    border-bottom: none;
                }

                a:last-of-type {
                    border-bottom: none;
                    display: inline-block;
                    padding: 0;
                    color: #fff;

                    .linktext {
                        font-size: 14px;
                        color: #fff;
                        padding-inline: 24px;
                        padding-block: 16px;
                        background: linear-gradient(0deg, #2AA1B6, #2AA1B6);
                        border: 0.5px solid #2AA1B6;
                        border-radius: 4px;
                    }
                }
            }

            #menuIcon {
                display: block;
            }

            .block {
                display: block;
            }



            .logo {
                height: 29.5px;

                img {
                    height: 100%;
                }
            }

            .menu {
                position: absolute;
                top: 100%;
                right: 0;
                left: 0;
                padding-bottom: 40px;
                background-color: white;

                a {
                    display: block;
                    border-bottom: 1px solid #D9D9D9;
                    font-size: 36px;

                    .linktext {
                        color: #000000;
                    }

                    .linktext.active {
                        color: #000000;
                    }
                }

                a:nth-last-of-type(2) {
                    border-bottom: none;
                }

                a:last-of-type {
                    border-bottom: none;
                    display: inline-block;
                    padding: 0;
                    color: #fff;

                    .linktext {
                        font-size: 14px;
                        color: #fff;
                        padding-inline: 24px;
                        padding-block: 16px;
                        background: linear-gradient(0deg, #2AA1B6, #2AA1B6);
                        border: 0.5px solid #2AA1B6;
                        border-radius: 4px;
                    }
                }
            }

            #menuIcon {
                display: block;
            }

            .block {
                display: block;
            }

            .hidden {
                display: none;
            }
        }
    }

    @media screen and (max-width:900px) {
        .center2 {
            width: 90% !important;
        }
    }
}


// .bottom-margin {
//     // position: relative;
//     // display: block;
//     // width: ;
//     border-bottom: 1px solid rgba(255, 255, 255, 1);
// }


// .rectangle-685,
// .rectangle-685 * {
//     box-sizing: border-box;
// }

// .rectangle-685 {
//     width: 1440px;
//     height: 760px;
//     position: relative;
//     overflow: visible;
// }
</style>